import React from 'react';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import SearchIcon from '@mui/icons-material/Search';
import Colors from '../../library/Colors';

/**
 * Shared toolbar pieces of the Documents page (manuals, update logs, templates).
 */

export const DocsSearch = ({ t, value, onChange }) => (
    <TextField
        size="small"
        type="search"
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={(e) => e.target.select()}
        placeholder={t('search')}
        sx={{ flex: '1 1 260px', minWidth: 200, '& .MuiInputBase-root': { height: 40, borderRadius: '8px' } }}
        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon sx={{ color: Colors.sft_blue }} /></InputAdornment> }}
    />
);

/**
 * Approval filter for admins: all / approved only / waiting for approval.
 * Maps onto the existing includeApproved + onlyApproved flags so the grid filtering stays the same.
 */
export const approvalMode = (includeApproved, onlyApproved) => (onlyApproved ? 'pending' : includeApproved ? 'all' : 'approved');

export const ApprovalFilter = ({ t, mode, onChange }) => (
    <ToggleButtonGroup size="small" exclusive value={mode} onChange={(e, v) => v && onChange(v)}
        sx={{ height: 40, '& .MuiToggleButton-root': { textTransform: 'none', px: 1.5, fontSize: 13.5 } }}>
        <ToggleButton value="all">{t('docs_filter_all')}</ToggleButton>
        <ToggleButton value="approved">{t('docs_filter_approved')}</ToggleButton>
        <ToggleButton value="pending">{t('docs_filter_pending')}</ToggleButton>
    </ToggleButtonGroup>
);

/** One application filter chip (icon + name); "all" has no icon. */
export const AppChip = ({ theme, label, icon, selected, onClick }) => {
    const dark = theme === 'dark';
    return (
        <ButtonBase onClick={onClick} focusRipple
            sx={{
                display: 'inline-flex', alignItems: 'center', gap: 0.75, height: 34, px: 1.25, borderRadius: '17px',
                fontSize: 13, fontWeight: selected ? 700 : 500, whiteSpace: 'nowrap',
                border: '1px solid ' + (selected ? Colors.sft_blue : dark ? 'rgba(255,255,255,0.14)' : Colors.light_accent_darker),
                backgroundColor: selected ? (dark ? 'rgba(0,113,187,0.25)' : 'rgba(0,113,187,0.08)') : 'transparent',
                color: selected ? (dark ? '#fff' : Colors.sft_blue) : 'text.primary',
                '&:hover': { borderColor: Colors.sft_blue },
            }}>
            {icon && <Box component="img" src={icon} alt="" loading="lazy" sx={{ width: 20, height: 20, objectFit: 'contain' }} />}
            {label}
        </ButtonBase>
    );
};
